import React, { FC } from "react";

import { TrackingLinkContainer } from "containers/shared/generic/tracking-link/tracking-link-container";

import { TRACKING_CATEGORY } from "constants/tracking";
import { APP_STORE_IOS } from "constants/app-store-link";

import { usePlansContext } from "store/plans/plans-context-provider";

import styles from "./ios-app-badge.module.scss";

export const IosAppBadgeContainer: FC = () => {
  const { selectedCity } = usePlansContext();

  return (
    <div className={styles.root}>
      <TrackingLinkContainer
        trackingData={{
          category: TRACKING_CATEGORY.USER_CLICK_ACTION,
          action: "Click on iOS app download button",
          label: `User's selected city: ${selectedCity?.name ?? "All cities"}`,
        }}
        className={styles.link}
        href={APP_STORE_IOS}
        target={"_blank"}
        rel="noreferrer"
      >
        <img
          className={styles.image}
          src="https://toolbox.marketingtools.apple.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1689811200"
          alt="Download on the App Store"
        />
      </TrackingLinkContainer>
    </div>
  );
};
